import { useCallback, ReactNode } from 'react';
import { Icon } from '@octano/global-ui';

type RemovableChipProps<T = unknown> = {
  value: T;
  children: ReactNode;
  onRemove?: (value: T) => void;
};

const RemovableChip = <T,>({
  value,
  children,
  onRemove,
}: RemovableChipProps<T>) => {
  const handleRemove = useCallback(() => {
    if (!onRemove) return;
    onRemove(value);
  }, [value, onRemove]);

  return (
    <button
      type="button"
      className="btn btn-outline-primary"
      disabled={!onRemove}
      onClick={onRemove ? handleRemove : undefined}
    >
      {children}
      {!!onRemove && <Icon name="close" size={12} className="ml-3" />}
    </button>
  );
};

export default RemovableChip;
